import React from "react";
import PropTypes from "prop-types";

import { Row, Col, DropdownButton, NavItem, Panel } from "react-bootstrap";
import { IoTrash, IoEllipsisVertical, IoEye } from "react-icons/io5";

import { orderBy } from "lodash";

import { formatDate } from "../../helpers/date";

const ExpenseReceiptList = ({
  receipts,
  onClickDelete,
  hideReceiptDelete,
  onClickDownload
}) => {
  let ExpenceReceiptView;

  if (receipts && receipts.length) {
    ExpenceReceiptView = (
      <Row>
        <div
          style={{
            textAlign: "center",
            color: "#b8bac5",
            fontWeight: "bold",
            paddingTop: "20px"
          }}
        />

        {orderBy(receipts, "modified_on", "desc").map((attachment, i) => {
          const timestamp = formatDate(attachment.created_on, "MM/dd/yyyy");
          return (
            <Panel
              bsStyle="info"
              key={attachment._id || i}
              className="attachment-panel"
              style={{
                background: "#F5F6FA",
                width: "90%",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <Panel.Body>
                <Col md={8} xs={5}>
                  <p style={{ textOverflow: "ellipsis" }}>{attachment.path}</p>
                </Col>
                <Col md={3} xs={5}>
                  <p className="pull-right">{timestamp}</p>
                </Col>

                <Col md={1} xs={2}>
                  <div className="actions pull-right">
                    <DropdownButton
                      title={
                        <span>
                          <IoEllipsisVertical />
                        </span>
                      }
                      id="dropdown"
                    >
                      <NavItem
                        onClick={() =>
                          onClickDownload(
                            attachment.path.replace(
                              "https://gfs-redkeep.s3.amazonaws.com/Expenses/",
                              ""
                            )
                          )
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <IoEye />
                        View
                      </NavItem>
                      {!hideReceiptDelete && (
                        <NavItem
                          onClick={() =>
                            onClickDelete(attachment._id || attachment.path)
                          }
                        >
                          <IoTrash />
                          Delete
                        </NavItem>
                      )}
                    </DropdownButton>
                  </div>
                </Col>
              </Panel.Body>
            </Panel>
          );
        })}
      </Row>
    );
  }

  return <div>{ExpenceReceiptView}</div>;
};

ExpenseReceiptList.propTypes = {
  receipts: PropTypes.array,
  onClickDelete: PropTypes.func,
  hideReceiptDelete: PropTypes.func,
  onClickDownload: PropTypes.func
};

export default ExpenseReceiptList;
